// Story 7.6 — admin_editorial card. The platform's own voice.
// Epic 8 — rendered on parchment (ParchmentPost) instead of the forest
// GreenholdFrame chrome.

import { useState } from "react";
import { Link } from "react-router-dom";

import { ParchmentPost, isLoadableImageUrl } from "@greenhold/components";

import { useAccountMe } from "../admin/useAccountMe";
import { relativeTime, wearSeed } from "./feedCardShared";
import type { FeedCard } from "./useFeed";

export function EditorialCard({ card }: { card: FeedCard }) {
  const [mediaError, setMediaError] = useState(false);
  // Admin affordance: edit this card in the cockpit without hunting it
  // down in the recent-history list. useAccountMe is cached SPA-wide,
  // so this costs no extra request; non-admins (and the cockpit's own
  // "preview" card, which has no real id) see nothing.
  const session = useAccountMe();
  const isAdmin = session.data?.data?.is_admin === true;

  return (
    <ParchmentPost
      author="Greenhold Newsroom"
      provenance="editorial"
      time={relativeTime(card.published_at)}
      title={card.title}
      pinned={card.is_pinned}
      seed={wearSeed(card.id)}
    >
      {card.body ? (
        <p className="m-0 whitespace-pre-line">{card.body}</p>
      ) : null}
      {isLoadableImageUrl(card.media_url) && !mediaError ? (
        <img
          src={card.media_url ?? undefined}
          alt=""
          loading="lazy"
          onError={() => setMediaError(true)}
          className="mt-3 max-h-80 w-full rounded object-cover"
        />
      ) : null}
      {isAdmin && card.id !== "preview" ? (
        <p className="m-0 mt-3 text-right">
          <Link
            to={`/admin/feed/editorial?edit=${card.id}`}
            className="font-mono text-xs uppercase tracking-wide opacity-60 underline decoration-dotted hover:opacity-100"
            data-testid="editorial-admin-edit-link"
          >
            Edit ✎
          </Link>
        </p>
      ) : null}
    </ParchmentPost>
  );
}
